var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94385 6.07099V13.88C4.94385 17.2277 7.66723 19.951 11.0148 19.951C14.3625 19.951 17.0858 17.2277 17.0858 13.88V6.07099C17.0858 2.72338 14.3625 0 11.0148 0C7.66723 0 4.94385 2.72338 4.94385 6.07099ZM14.9867 6.07099V13.88C14.9867 16.071 13.2058 17.8519 11.0148 17.8519C8.8239 17.8519 7.04299 16.071 7.04299 13.88V6.07099C7.04299 3.88005 8.8239 2.09914 11.0148 2.09914C13.2058 2.09914 14.9867 3.88005 14.9867 6.07099Z",
    fill: "#2D49FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0539 12.8335C19.4725 12.8335 19.0012 13.3047 19.0012 13.88C19.0012 18.2864 15.4149 21.8727 11.0086 21.8727C6.6022 21.8727 3.01591 18.2864 3.01591 13.88C3.01591 13.2986 2.54467 12.8335 1.96328 12.8335C1.38188 12.8335 0.910645 13.3047 0.910645 13.88C0.910645 19.0881 4.87637 23.3904 9.94981 23.9167V27.9008H6.44308C5.86168 27.9008 5.39045 28.3721 5.39045 28.9534C5.39045 29.5348 5.86168 30 6.44308 30H15.5557C16.1371 30 16.6083 29.5287 16.6083 28.9534C16.6083 28.3721 16.1371 27.9008 15.5557 27.9008H12.049V23.9167C17.1224 23.3904 21.0881 19.0881 21.0881 13.88C21.1065 13.3047 20.6352 12.8335 20.0539 12.8335Z",
    fill: "#2D49FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/Microphone.5b8e6d94.svg";
export { ForwardRef as ReactComponent };